// extracted by mini-css-extract-plugin
module.exports = {"employeeRowActionIcon":"heIfE","statusModalUser":"AF9ZY"};